import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";

import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';

const useStyles = makeStyles(theme => ({
  root: {
    paddingTop: theme.spacing(10),
    paddingBottom: theme.spacing(10)
  },
  grid: {
  },
  container: {
    maxWidth: '595px'
  },
  image: {
    width: '100%',
    height: 'auto'
  },
  paper: {
    padding: theme.spacing(6),
  },
  title: {
    textTransform: 'uppercase',
    marginBottom: theme.spacing(1) / 2,
    fontFamily: theme.headings.fontFamily,
  },
  subtitle: {
    marginBottom: theme.spacing(2),
    fontWeight: 400,
  },
  eventdate: {
    textTransform: 'uppercase',
    marginBottom: theme.spacing(2),
    letterSpacing: '1px',
    color: theme.palette.error.dark
  },
  text: {
    whiteSpace: 'pre-line',
    marginBottom: theme.spacing(5),
  },
  buttons: {
  },
  buttonDefault: {
    marginRight: theme.spacing(2),
  },
}));

export default (props) => {
  const history = useHistory();

  useEffect(() => {
    if (props.isAuthenticated) {
      history.push("/event");
    }
  }, [props.isAuthenticated, history]);
  
  const handleLogin = async () => {
    history.push("/login");
  }
  const handleRegister = async () => {
    history.push("/register");
  }
  const classes = useStyles();
  return (
    <>
      { !props.isAuthenticated &&
        <div className={classes.root}>
          <Container>
            <Grid container direction="row" className={classes.grid} spacing={3}>
              <Grid item xs={12} md={6} lg={7} >
                <div className={classes.container}><img src={props.config.homePanel.imageUrl} alt={props.config.homePanel.imageAlt} className={classes.image} /></div>
              </Grid>
              <Grid item xs={12} md={6} lg={5} >
                <Paper className={classes.paper}>
                  <h1 className={classes.title}>{props.config.homePanel.title}</h1>
                  <h3 className={classes.subtitle}>{props.config.homePanel.subtitle}</h3>
                  <h5 className={classes.eventdate}>{props.config.homePanel.eventDate}<br />{props.config.homePanel.eventTime}</h5>
                  <p className={classes.text}>{props.config.homePanel.description}</p>
                  <div className={classes.buttons}>
                    <Button color="secondary" variant="outlined" onClick={handleLogin} className={classes.buttonDefault} >Login</Button>
                    <Button color="secondary" variant="contained" onClick={handleRegister} disableElevation>Register</Button>
                  </div>
                </Paper>
              </Grid>
            </Grid>
          </Container>
        </div>
      }
    </>
  );
};